/** @format */

import React, { useMemo, memo } from 'react';
import { Select, Spin } from 'antd';
import { useCampaigns } from 'features/campaigns/hooks/useCampaigns';

interface CampaignDropdownProps {
  officeId: string;
  value?: string;
  onChange?: (vendorName: string) => void;
}

/**
 * Campaign Dropdown Component
 * Fetches campaigns by office ID and displays vendor names
 */
const CampaignDropdown: React.FC<CampaignDropdownProps> = ({ officeId, value, onChange }) => {
  const { campaigns, loading } = useCampaigns(officeId);

  const options = useMemo(() => {
    if (!campaigns || campaigns.length === 0) return [];
    return campaigns.map((campaign: any) => ({
      label: campaign.vendorName,
      value: campaign.vendorName,
    }));
  }, [campaigns]);

  if (!officeId || officeId.length === 0) {
    return <span>No office selected</span>;
  }

  return (
    <Spin spinning={loading}>
      <Select
        showSearch
        placeholder='Select Campaign'
        value={value || undefined}
        onChange={onChange}
        options={options}
        style={{ width: '100%' }}
        virtual={false}
        listHeight={400}
        filterOption={(input, option) =>
          (option?.label as string)?.toLowerCase().includes(input.toLowerCase())
        }
      />
    </Spin>
  );
};

export default memo(CampaignDropdown, (prevProps, nextProps) => {
  return (
    prevProps.officeId === nextProps.officeId &&
    prevProps.value === nextProps.value
  );
});



